import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  moveAccountCompany,
  searchAdminAccounts,
  setInternalDev,
} from "../services/accountAdminService";
import type {
  MoveAccountCompanyRequest,
  SetInternalDevRequest,
} from "../types/account.types";

export const ADMIN_ACCOUNT_QK = {
  search: (keyword: string) => ["adminAccounts", keyword] as const,
  all: () => ["adminAccounts"] as const,
};

export const useAdminAccountSearch = (keyword: string) =>
  useQuery({
    queryKey: ADMIN_ACCOUNT_QK.search(keyword),
    queryFn: () => searchAdminAccounts(keyword),
    enabled: keyword.trim().length > 0,
    staleTime: 0,
  });

export const useMoveAccountCompany = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: MoveAccountCompanyRequest) => moveAccountCompany(req),
    onSuccess: (message) => {
      toast.success(message || "업체를 변경했습니다.");
      qc.invalidateQueries({ queryKey: ADMIN_ACCOUNT_QK.all() });
    },
    onError: (err: Error) => {
      toast.error(`업체 변경 실패: ${err.message}`);
    },
  });
};

export const useSetInternalDev = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: SetInternalDevRequest) => setInternalDev(req),
    onSuccess: (message) => {
      toast.success(message || "내부 개발자 설정을 변경했습니다.");
      qc.invalidateQueries({ queryKey: ADMIN_ACCOUNT_QK.all() });
    },
    onError: (err: Error) => {
      toast.error(`설정 변경 실패: ${err.message}`);
    },
  });
};
